export const suspendedLocationRouteNames = {
  default: 'suspended_location',
}
